import { Typography } from 'antd';

interface ShortcutGroup {
  title: string;
  shortcuts: { keys: string[]; description: string }[];
}

const GROUPS: ShortcutGroup[] = [
  {
    title: 'Navigation',
    shortcuts: [
      {
        keys: ['⌘/Ctrl', 'K'],
        description:
          'Open the command palette — search requests, collections, and folders, or run a command',
      },
    ],
  },
  {
    title: 'Requests',
    shortcuts: [
      { keys: ['⌘/Ctrl', 'Enter'], description: 'Send the active request' },
      { keys: ['⌘/Ctrl', 'S'], description: 'Save the active request' },
      { keys: ['Enter'], description: 'Send the active request (while the URL field is focused)' },
    ],
  },
  {
    title: 'Tabs',
    shortcuts: [
      { keys: ['⌘/Ctrl', 'Shift', 'T'], description: 'Reopen the last closed request tab' },
      { keys: ['Right-click a tab'], description: 'Pin, duplicate, or close tabs' },
      { keys: ['Drag a tab'], description: 'Reorder open tabs' },
    ],
  },
  {
    title: 'Resizable panels',
    shortcuts: [
      { keys: ['Tab'], description: 'Focus a divider between two panels' },
      { keys: ['↑ / ↓ / ← / →'], description: 'Resize the focused divider by a small step' },
      {
        keys: ['Shift', '↑ / ↓ / ← / →'],
        description: 'Resize the focused divider by a larger step',
      },
      {
        keys: ['Double-click'],
        description: 'Toggle a divider between its default and expanded layout',
      },
    ],
  },
];

const Keycap = ({ label }: { label: string }) => (
  <kbd className="rounded border border-black/15 bg-black/5 px-1.5 py-0.5 font-mono text-xs dark:border-white/15 dark:bg-white/10">
    {label}
  </kbd>
);

export const KeyboardShortcutsTab = () => (
  <div className="max-w-2xl space-y-6">
    {GROUPS.map((group) => (
      <div key={group.title}>
        <Typography.Title level={5}>{group.title}</Typography.Title>
        <div className="divide-y divide-black/5 dark:divide-white/10">
          {group.shortcuts.map((shortcut) => (
            <div
              key={shortcut.description}
              className="flex items-center justify-between gap-4 py-2"
            >
              <span className="text-sm text-gray-600 dark:text-gray-300">
                {shortcut.description}
              </span>
              <span className="flex shrink-0 items-center gap-1">
                {shortcut.keys.map((key, index) => (
                  <span key={key} className="flex items-center gap-1">
                    {index > 0 && <span className="text-xs text-gray-400">+</span>}
                    <Keycap label={key} />
                  </span>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
